export const pillars = [
  {
    name: 'Certificado',
    text: 'Obtenha o selo oficial de Certificado do ECBR DNA e mostre ao mercado seu nível de excelência'
  },
  {
    name: 'Eleve a régua',
    text: 'Compreenda os pontos críticos que precisam de melhorias em seu e-commerce e eleve a régua'
  },
  {
    name: 'Melhore seus diferenciais',
    text: 'Compreenda a pontuação de mercado para melhorar seus diferenciais competitivos e vender mais'
  }
]

export const info = [
  {
    title: 'Como funciona?',
    text: 'Através do ECBR DNA você conseguirá compreender o nível de maturidade de seu e-commerce e saberá os pontos mais importantes que precisa evoluir. Ao atender os critérios de avaliação da certificação sua empresa alcançará o certificado de excelência ECBR DNA.',
    eventKey: '0'
  },
  {
    title: 'Porque devo tirar a certificação',
    text: 'O ECBR DNA ajudará sua empresa a basilar os skills do seu negócio com os indicadores de mercado, ou seja, é uma forma de compreender a excelência do seu negócio frente ao mercado e receber indicações claras e precisas de quais áreas do negócio podem ser melhoradas. Muito além de uma certificação, o ECBR DNA te dará uma visão clara de como elevar a régua do seu e-commerce.',
    eventKey: '1'
  }
]

export const benefits = [
  {
    title: 'Reconhecimento',
    text: 'Sua empresa reconhecida pelo mercado com o selo de padrão de excelência do ECBR DNA '
  },
  {
    title: 'Melhoria Contínua',
    text: 'O ECBR DNA ajuda sua empresa a identificar pontos de melhoria e seguir crescendo'
  },
  {
    title: 'Evita erros e desperdício',
    text: 'Com o ECBR DNA sua empresa se concentra nos pontos de melhoria para crescer cada dia mais'
  }
]
